module.exports = __webpack_public_path__ + "img/MaidenofWax.eec24df7.png";